export default class UserProductGroupStatus {
	id: string;

	status: string;

	constructor(id: string, status: string) {
		this.id = id;
		this.status = status;
	}

	isRemoved(): boolean {
		return this.status === 'removed';
	}
}
